import classNames from 'classnames';
import React from 'react';

export interface SectionContainerProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
}

const SectionContainer = ({ children, className, id }: SectionContainerProps): JSX.Element => {
  return (
    <div className="mobile-lg:grid-col-6 desktop:grid-col-3">
      <section
        id={id}
        className={classNames(className, 'usa-footer__primary-content usa-footer__primary-content--collapsible')}
      >
        {children}
      </section>
    </div>
  );
};

export default SectionContainer;
